import React, { useEffect } from 'react';

declare global {
    interface Window {
        adsbygoogle: any;
    }
}

interface AdComponentProps {
    adSlot?: 'auto' | 'list' | 'article';
    adFormat?: string;
    adLayoutKey?: string;
}

const AdComponent: React.FC<AdComponentProps> = ({ adSlot, adFormat = 'auto', adLayoutKey }) => {
    useEffect(() => {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
            console.error('AdSense error:', e);
        }
    }, [adSlot, adFormat, adLayoutKey]);

    return (
        <div style={{ margin: '1rem 0', textAlign: 'center' }}>
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-5125986043667921"
                data-ad-slot={{
                    'auto': '2479850682',
                    'article': '2267252170',
                    'list': '9621593042',
                }[adSlot ?? 'auto']}
                data-ad-format={adFormat}
                data-ad-layout-key={adLayoutKey}
                data-full-width-responsive="true"></ins>
        </div>
    );
};

export default AdComponent;
